import React from "react";
import { Box, Text } from "@chakra-ui/react";
export const DigitalClock = ({ backgroundColor = "#FFFFFF", color = "#333333", widgetWidth, date, fontFamily = "Rubik", rounded = true, format = "24h", }) => {
    const hours = (format === "24h" ? date.getHours() : date.getHours() % 12)
        .toString()
        .padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return (React.createElement(Box, { backgroundColor: backgroundColor, color: color, fontFamily: fontFamily, p: `${(4 / 50) * widgetWidth}px`, borderRadius: rounded ? `${(4 / 50) * widgetWidth}px` : undefined, fontSize: `${(16 / 50) * widgetWidth}px`, width: `${widgetWidth}px` },
        React.createElement(Text, { lineHeight: "70%", textAlign: "center", sx: {
                wordWrap: "normal",
            } },
            hours,
            ":",
            minutes)));
};
